module.exports = __webpack_public_path__ + "static/img/post_9.4d62839.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/posts/post_9.png
// module id = mxJS
// module chunks = 0